// AngularJs - Libs
require('./ng/main');

// AngularJs - App Source
require('./ng/cipo.module');

// Angular - Bootstrap the app
require('./polyfills');
require('./bootstrap');